import React from 'react';

/**
 * A table cell component
 *
 * @displayName Td
 * @class Td
 * @extends {React.Component}
 */
export default class Td extends React.Component {
  /**
   * Render a table cell.
   *
   * @returns {ReactElement} Table cell.
   * @public
   */
  render() {
    return <td { ...this.props }></td>;
  }
}
